import * as OrderService from 'services/otr/otr-order-service';
import * as OrderLegService from 'services/otr/otr-leg-service';
import { saveOrderExpense, updateOrderExpense, deleteOrderExpense } from 'services/otr/otr-expense-service';


export function resetState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function setActiveOrder(order) {
  return function (dispatch) {
    dispatch(success('OTR_SET_CURRENT_ORDER', order));
  };
}

export function listOrders(appointment, start, end, from, size) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.getDispatchOrders(appointment, start, end, from, size);
      dispatch(success('OTR_FETCH_ORDERS', response.data));
    } catch(err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export const fetchDataPeriodically = () => (dispatch) => {
  const fetchData = async () => {
    try {
      var now = new Date().toISOString();
      var nowMinusOne = new Date(Date.now() - 60000).toISOString();
      const response = await OrderService.getLoads(nowMinusOne, now, 0, 50);
      if(response.data && response.data.content && response.data.content.length) {
        dispatch(success('OTR_STATE_CHANGE', response.data));
      }
    } catch(err) {
    }
  };
  const interval = setInterval(fetchData, 15000);
  return () => clearInterval(interval);
};

export function search(params) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.search(params);
      dispatch(success('OTR_SEARCH_ORDER_SUCCESS', response.data));
    } catch(err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

// Order Detail Actions
export function getOTROrderById(orderId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.getOrderById(orderId);
      dispatch(success('OTR_FETCH_CURRENT_ORDER', response.data));
    } catch(err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function getOrderLegById(legId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.getLeg(legId);
      dispatch(success('OTR_FETCH_LEG', response.data));
    } catch(err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function setNextStatusForOrder(orderId, leg, timestamp, action, address) {
  return async function (dispatch) {
    dispatch(process());
    const response = await OrderService.setNextStatusForOrder(orderId, leg, timestamp, action, address);
    try {
      dispatch(success('OTR_STATUS_CHANGE', response.data));
    } catch(err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function save(order) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.save(order);
      dispatch(success('OTR_ADD_ORDER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function update(order) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.update(order);
      dispatch(success('OTR_UPDATE_ORDER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function deleteOrder(orderId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.deleteOrder(orderId);
      dispatch(success('OTR_DELETE_ORDER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }    
  };
}

export function deleteOrderLeg(legId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.deleteLeg(legId);
      dispatch(success('OTR_DELETE_ORDER_LEG', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }    
  };
}

export function saveOrderLeg(leg) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.save(leg);
      dispatch(success('OTR_ADD_ORDER_LEG', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

// export function updateOrderRate(orderId, order) {
//   return async function (dispatch) {
//     dispatch(process());
//     try {
//       const response = await OrderService.updateOrderRate(orderId, order);
//       dispatch(success('UPDATE_OTR_ORDER_RATE', response.data));
//     } catch (err) {
//       dispatch(error('OTR_ORDER_ERROR', err));
//     }
//   };
// }

export function updateOrderLocation(orderId, legId, locationId, orderLocation, locationType) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.updateOrderLocation(orderId, legId, locationId, orderLocation, locationType);
      dispatch(success('OTR_UPDATE_ORDER_LOCATION', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function updateOrderEquipment(orderId, truckId, truck) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.updateOrderEquipment(orderId, truckId, truck);
      dispatch(success('OTR_UPDATE_ORDER_EQUIPMENT', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function updateOrderSummary(orderId, orderSummary) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderService.updateOrderSummary(orderId, orderSummary);
      dispatch(success('OTR_UPDATE_ORDER_SUMMARY', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function assignDriver(legId, driver) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.assignDriver(legId, driver);
      dispatch(success('OTR_ASSIGN_DRIVER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function unassignDriver(legId, driver) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.unassignDriver(legId, driver);
      dispatch(success('OTR_UNASSIGN_DRIVER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function changeDriver(legId, driver) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.changeDriver(legId, driver);
      dispatch(success('OTR_CHANGE_DRIVER', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

/* Driver Rate */
export function updateDriverRate(legId, driverRate) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.updateLegRate(legId, driverRate);
      dispatch(success('OTR_CHANGE_DRIVER_RATE', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

/* Leg Charges */
export function saveCharge(legId, driverId, charges) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.saveLegCharges(legId, driverId, charges);
      dispatch(success('OTR_SAVE_LEG_CHARGE', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

export function updateCharge(legId, driverId, charges) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.updateLegCharges(legId, driverId, charges);
      dispatch(success('OTR_UPDATE_LEG_CHARGE', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}
 
export function deleteCharge(legId, chargeId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await OrderLegService.deleteLegCharge(legId, chargeId);
      dispatch(success('OTR_DELETE_LEG_CHARGE', response.data));
    } catch (err) {
      dispatch(error('OTR_ORDER_ERROR', err));
    }
  };
}

/* TODO: Expense */
export function saveExpense(orderId, expense) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await saveOrderExpense(orderId, expense);
      dispatch(success('OTR_SAVE_EXPENSE', response.data));
    } catch (err) {
      dispatch(error('OTR_EXPENSE_ERROR', err));
    }
  };
}

export function updateExpense(orderId, expense) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await updateOrderExpense(orderId, expense);
      dispatch(success('OTR_UPDATE_EXPENSE', response.data));
    } catch (err) {
      dispatch(error('OTR_EXPENSE_ERROR', err));
    }
  };
}

export function deleteExpense(orderId, expenseId) {
  return async function (dispatch) {
    dispatch(process());
    try {
      await deleteOrderExpense(expenseId, orderId);
      dispatch(success('OTR_DELETE_EXPENSE', expenseId));
    } catch (err) {
      dispatch(error('OTR_EXPENSE_ERROR', err));
    }
  };
}

export function reset(type) {
  return {
    type: type
  };
}

export function process() {
  return {
    type: 'OTR_PROCESSING_ORDER',
    payload: true
  };
}

export function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}

export function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}